import ModuleWrapper from 'shared-lib/containers/Module';

const TrafficControl = () => import(/* webpackChunkName: "traffic-control" */ '@/views/trafficControl/TrafficControl');

const meta = (data = {}) => ({
    privilegeModule: 'traffic_control',
    permission: 'read',
    auth: true,
    ...data,
});

export default [{
    path: 'traffic-control',
    component: ModuleWrapper,
    meta: meta({
        title: 'TrafficControl',
    }),
    children: [
        {
            path: '',
            name: 'TrafficControl',
            component: TrafficControl,
            meta: meta(),
        },
    ],
}];
